var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"post-level",style:({ backgroundColor: _vm.level.color })},[_vm._l((_vm.level.int),function(index){return _c('i',{staticClass:"fas fa-star"})}),_vm._v("\n    "+_vm._s(_vm.level.name)+"\n  ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }